import React, { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getUserAttribute, UserAttributes } from "shared-auth";
import { parseQuery } from "shared/utils/http";
import { UserManager } from "core";
import { PROFILE_EDIT_VIEW_QUERY_PARAM } from "shared/constants";

function withArtistRef<P>(
  WrappedComponent: React.ComponentType<React.PropsWithChildren<P>>
): React.FC<React.PropsWithChildren<P>> {
  return (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const editQueryParam = searchParams.get(PROFILE_EDIT_VIEW_QUERY_PARAM);
    const { artistref } = parseQuery(location.search);

    useEffect(() => {
      const performerId = getUserAttribute(UserAttributes.UserIdPerformer);

      UserManager.artistRef = performerId || artistref || UserManager.artistRef;

      if (artistref) {
        searchParams.delete("artistref");

        navigate(
          {
            pathname: location.pathname,
            search: editQueryParam ? searchParams.toString() : "",
          },
          { replace: true }
        );
      }
    }, [artistref, location.pathname, editQueryParam]);

    return <WrappedComponent {...props} />;
  };
}

export default withArtistRef;
